const STORAGE_TYPE =
  typeof window.localStorage !== "undefined" ? window.localStorage : null;

export const STORAGE_KEY = "edexlms2.0-store";

export const getItem = (key) => {
  return STORAGE_TYPE == null ? null : STORAGE_TYPE.getItem(key);
};

export const setItem = (key, value) => {
  if (STORAGE_TYPE !== null) {
    STORAGE_TYPE.setItem(key, value);
  }
};

export const clearAll = () => {
  if (STORAGE_TYPE !== null) {
    STORAGE_TYPE.clear();
  }
};

// Flags that say a request is on its way. No request survives a page reload,
// so a state restored from storage must not say one is: nothing would ever
// finish it (for example Prepare download would stay busy for good after a
// reload during a certificate batch create).
const IN_FLIGHT_FLAGS = [
  "requesting",
  "creating",
  "previewRequesting",
  "itemsRequesting",
  "audiencesRequesting",
  // An organisation's licence, entitlements and activation saves.
  "licenseSaving",
  "entitlementsSaving",
  "activating",
  // My Rewards' own loads (self slice).
  "rewardsRequesting",
  "pointsHistoryRequesting",
  "learningProgramsRequesting",
];

// Slices that are never saved in the browser: the audit log holds other
// people's names, emails and field changes, and is loaded again when its
// screen opens.
const UNSAVED_SLICES = ["auditLogs"];

export const withoutUnsavedSlices = (state) =>
  Object.fromEntries(
    Object.entries(state || {}).filter(([name]) => !UNSAVED_SLICES.includes(name))
  );

const isPlainObject = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

// The stored state with every request that was on its way settled: its
// in-flight flags false, and the saved reports' Send now list empty.
//
// A request cut off by the reload is neither a success nor a failure, so the
// slice's action is forgotten as well (set to null). Kept, it read as a
// request that succeeded (requesting false, no error), and screens that act
// on a settled action acted on it: the header logged out after a password
// change that may never have reached the server, an add screen went back to
// its list (review M1).
export const withoutRequestsInFlight = (state) =>
  Object.fromEntries(
    Object.entries(withoutUnsavedSlices(state)).map(([name, slice]) => {
      if (!isPlainObject(slice)) {
        return [name, slice];
      }
      const settled = { ...slice };
      let cutOff = false;
      IN_FLIGHT_FLAGS.forEach((flag) => {
        if (settled[flag] === true) {
          settled[flag] = false;
          cutOff = true;
        }
      });
      if (Array.isArray(settled.sendingNow) && settled.sendingNow.length > 0) {
        settled.sendingNow = [];
        cutOff = true;
      }
      if (cutOff && "action" in settled) {
        settled.action = null;
      }
      return [name, settled];
    })
  );
